module.exports = __webpack_public_path__ + "img/IMG_9181-224_L_Wood_MockedUp.614ae250.jpg";